"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("../../../theme/makeStyles");
exports.default = (0, makeStyles_1.makeStyles)(function () { return ({
    xsmall: {
        fontSize: '24px'
    },
    small: {
        fontSize: '40px'
    },
    medium: {
        fontSize: '64px'
    },
    large: {
        fontSize: '120px'
    }
}); });
